import React from 'react';

function Form({ formData, setFormData, copyToClipboard }) {
    
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  return (
    <div className="input-form">
      <label htmlFor="name">Name:</label>
      <input name="name" type="text" value={formData.name} onChange={handleInputChange} /><br/>

      <label htmlFor="email">Email:</label>
      <input name="email" type="email" value={formData.email || ''} onChange={handleInputChange} /><br/>

      <label htmlFor="title">Role or Title:</label>
      <input name="title" type="text" value={formData.title} onChange={handleInputChange} /><br/>

      <label htmlFor="unit">Unit/Department:</label>
      <input name="unit" type="text" value={formData.unit} onChange={handleInputChange} /><br/>

      <label htmlFor="location">Location:</label>
      <input name="location" type="text" value={formData.location} onChange={handleInputChange} /><br/>

      <label htmlFor="dsn">Phone:</label>
      <input name="dsn" type="text" value={formData.dsn} onChange={handleInputChange} /><br/>

      <button type="button" onClick={copyToClipboard}>Copy</button>
    </div>
  );
}

export default Form;
